'use client'

import SubMenu from './sub-menu'
import { CMSLink } from '@/components/Link'
import Link from 'next/link'

import { ChevronDown, ChevronsRight } from 'lucide-react'

export const Header4 = ({
  navItems,
  logo,
  rightCta,
}: {
  navItems: any
  logo: any
  rightCta?: any
}) => {
  return (
    <div className="bg-[#FFF4F3] py-3  px-4 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center space-x-24">
        <div className="relative">
          <Link href="/" className="">
            {logo?.url && (
              <img
                src={logo?.url}
                alt="Titan Fence & Supply Company - Est. 2009 - Crossroads, Texas"
                className=" w-32 h-auto cursor-pointer "
              />
            )}
          </Link>
        </div>
        <div className="flex items-center gap-8 flex-1 justify-center  ">
          {navItems?.map((item: any, index: any) => {
            return (
              <div
                className="text-left cursor-pointer relative group "
                key={`index-${index}-${item?.link?.label}`}
              >
                <Link
                  href={item?.link?.url || '/'}
                  className="flex items-center  text-[18px] font-medium capitalize text-white relative z-[1] transition-all duration-500"
                >
                  <h3 className="text-[16px] text-black transition-colors group font-bold">
                    {item?.link?.label}
                  </h3>
                  {!!item?.subMenuItems?.length && (
                    <ChevronDown className="text-black text-[16px] font-bold" />
                  )}
                  <span className="absolute h-[2px] bottom-0 bg-red-500   scale-x-0 group-hover:scale-x-100 transition-transform  z-[-1] w-full"></span>
                </Link>

                {!!item?.subMenuItems?.length && <SubMenu items={item?.subMenuItems} />}
              </div>
            )
          })}
        </div>
        {rightCta &&
          rightCta?.map((item: any, index: any) => {
            return (
              <div
                className="relative overflow-hidden group rounded-full inline-flex"
                key={item?.id || index}
              >
                <CMSLink
                  {...item.link}
                  className="relative z-10 inline-flex items-center border border-border hover:border-destructive cursor-pointer text-black font-semibold text-base tracking-wide transition-all duration-500 ease-out rounded-full px-6 py-8 bg-transparent hover:bg-destructive hover:text-white"
                >
                  <div className="w-12 h-12 rounded-full flex items-center justify-center ml-2 bg-destructive text-white group-hover:bg-card group-hover:text-destructive">
                    <ChevronsRight />
                  </div>
                </CMSLink>

                <div className="absolute inset-0 bg-destructive origin-center rotate-[-45deg] scale-y-0 group-hover:scale-y-[5] transition-transform duration-500 ease-in-out rounded-full z-0" />
              </div>
            )
          })}
      </div>
    </div>
  )
}
